import { CallApiOptions } from './api';

export const postImageCallOptions = (body: any): CallApiOptions => ({
  method: 'POST',
  endpoint: `images`,
  noContentType: true,
  body,
});



// WEBPACK FOOTER //
// ./src/services/media.service.ts